// const consoleSolutionStaticPath = {
// 	'10052-24A': '/static/leave-management',
// 	'10063-24A': '/static/my-attendance',
// 	'10059-24A': '/static/attendance-management',
// 	'10070-2501': '/static/control-self-assurance',
// 	'10081-2501': '/static/control',
// 	'10085-2501': '/static/budgetary-control',
// 	'10084-2501': '/static/lease-schedule',
// 	'10095-2501': '/static/lease-schedule-v2',
// 	'10097-2501': '/static/lease-schedule-v4',
// 	'10104-2501': '/static/lease-schedule-v5',
// 	'10102-2501': '/static/lease-schedule-v6',
// 	'10148-2501': '/static/lease-schedule-v9',
// 	'10187-2501': '/static/lease-accounting-v10',
// 	'10114-2501': '/static/decommission-asset-accounting',
// 	'10110-2501': '/static/lease-schedule-v7',
// 	'10019-2501': '/static/petty-cash-float-dashboard',
// 	'10020-2501': '/static/petty-cash-reconciliation-dashboard',
// 	'10026-2501': '/static/petty-cash-transaction',
// 	'10027-2501': '/static/petty-cash-transaction-for-cashier',
// 	'10130-2501': '/static/control-self-assurance-v2',
// 	'10134-2501': '/static/kpi-console',
// 	'10145-2501': '/static/team-kpi-evaluation',
// 	'10143-2501': '/static/invoice-ap-console',
// 	'10144-2501': '/static/invoice-treasury-console',
// 	'10163-2501': '/static/lease-payable-v9',
// 	'10186-2501': '/static/lease-payable-approval-v9',
// 	'10164-2501': '/static/fixed-asset-register',
// 	'10168-2501': '/static/tax-payable',
// 	'10194-2501': '/static/salary-management',
// 	'10289-2501': '/static/kpi-comparative-console',
// 	'10293-2501': '/static/acting-position-overview',

// 	'10302-2601': '/static/rate-agreement',
// 	'10300-2601': '/static/project-milestone',
// 	'10301-2601': '/static/rental-subscription',
// 	'10007-24A': '/static/consolidated-contract-administration',
// 	'10306-2601': '/static/lead-kanban',
// 	'10314-2601': '/static/lead-ingestion-pool',
// 	'10315-2601': '/static/lead-screening',
// 	'10316-2601': '/static/lead-assignment',
// 	'10317-2601': '/static/lead-workbench',
// 	'10349-2601': '/static/pre-litigation-kanban',
// 	'10348-2601': '/static/pre-litigation-workbench',
// 	'10321-2601': '/static/lead-back-office-workbench-v2',
// };

// const policySolutionStaticPath = {
// 	'10127-2501': '/static/leave-combine',
// };

// const identitySolutionStaticPath = {
// 	'10068-2501': '/static/committee',
// 	'10147-2501': '/static/lease-record-management-v9',
// 	'10101-2501': '/static/lease-record-management-v6',
// 	'10309-2601': '/static/raw-lead-records',
// 	'10113-2501': '/static/decommission-asset',
// 	// '10126-2501': '/static/key-performance-indicator',
// 	// '10133-2501': '/static/kpi-evaluation',
// };

// const taskSolutionStaticPath = {};

// const allStaticSolutionPath = {
// 	...identitySolutionStaticPath,
// 	...policySolutionStaticPath,
// 	...taskSolutionStaticPath,
// };

const getLocalSolutionURLByVertical = () => {
	try {
		const raw = localStorage.getItem('solutionURLByVertical');
		if (!raw) return {};
		const parsed = JSON.parse(raw);
		return parsed && typeof parsed === 'object' ? parsed : {};
	} catch (error) {
		return {};
	}
};

const getCompanyCode = () => {
	try {
		return localStorage.getItem('companyCode') || '';
	} catch (error) {
		return '';
	}
};

// Flat lookup: solutionURLByVertical[companyCode-processCode-processVersion]
export const solutionURLByVertical = {};

const localSolutionURLByVertical = getLocalSolutionURLByVertical();
Object.assign(solutionURLByVertical, localSolutionURLByVertical);

// if (!solutionURLByVertical['24155-10409-2601']) {
// 	solutionURLByVertical['24155-10409-2601'] = '/static/ocr-ai-solution';
// }

// if (!solutionURLByVertical['24155-10409-2501']) {
// 	solutionURLByVertical['24155-10409-2501'] = '/static/ocr-ai-solution';
// }

if (
	!solutionURLByVertical['24155-10355-2601'] ||
	solutionURLByVertical['24155-10355-2601'] === '/static/litigation-type' ||
	solutionURLByVertical['24155-10355-2601'] === '/static/pre-litigation-litigation-type'
) {
	solutionURLByVertical['24155-10355-2601'] = '/case-identity';
}

if (!solutionURLByVertical['24155-10337-2601'] || solutionURLByVertical['24155-10337-2601'] === '/static/procurement-type') {
	solutionURLByVertical['24155-10337-2601'] = '/case-identity';
}

if (!solutionURLByVertical['24155-10339-2601'] || solutionURLByVertical['24155-10339-2601'] === '/static/raw-sourcing-request') {
	solutionURLByVertical['24155-10339-2601'] = '/case-identity';
}

if (
	!solutionURLByVertical['24155-10355-2501'] ||
	solutionURLByVertical['24155-10355-2501'] === '/static/litigation-type' ||
	solutionURLByVertical['24155-10355-2501'] === '/static/pre-litigation-litigation-type'
) {
	solutionURLByVertical['24155-10355-2501'] = '/case-identity';
}

if (!solutionURLByVertical['24155-10337-2501'] || solutionURLByVertical['24155-10337-2501'] === '/static/procurement-type') {
	solutionURLByVertical['24155-10337-2501'] = '/case-identity';
}

if (!solutionURLByVertical['24155-10339-2501'] || solutionURLByVertical['24155-10339-2501'] === '/static/raw-sourcing-request') {
	solutionURLByVertical['24155-10339-2501'] = '/case-identity';
}

if (
	!solutionURLByVertical['24155-10356-2601'] ||
	solutionURLByVertical['24155-10356-2601'] === '/static/litigation-stages-hierarchy' ||
	solutionURLByVertical['24155-10356-2601'] === '/static/litigation-stage-hierarchy'
) {
	solutionURLByVertical['24155-10356-2601'] = '/case-identity';
}

if (
	!solutionURLByVertical['24155-10343-2601'] ||
	solutionURLByVertical['24155-10343-2601'] === '/static/supply-chain-stages-hierarchy' ||
	solutionURLByVertical['24155-10343-2601'] === '/static/supply-chain-stage-hierarchy'
) {
	solutionURLByVertical['24155-10343-2601'] = '/case-identity';
}

if (
	!solutionURLByVertical['24155-10356-2501'] ||
	solutionURLByVertical['24155-10356-2501'] === '/static/litigation-stages-hierarchy' ||
	solutionURLByVertical['24155-10356-2501'] === '/static/litigation-stage-hierarchy'
) {
	solutionURLByVertical['24155-10356-2501'] = '/case-identity';
}

if (
	!solutionURLByVertical['24155-10343-2501'] ||
	solutionURLByVertical['24155-10343-2501'] === '/static/supply-chain-stages-hierarchy' ||
	solutionURLByVertical['24155-10343-2501'] === '/static/supply-chain-stage-hierarchy'
) {
	solutionURLByVertical['24155-10343-2501'] = '/case-identity';
}

if (!solutionURLByVertical['24155-10357-2601'] || solutionURLByVertical['24155-10357-2601'] === '/static/litigation-lifecycle-effort-profile') {
	solutionURLByVertical['24155-10357-2601'] = '/case-identity';
}

if (!solutionURLByVertical['24155-10345-2601'] || solutionURLByVertical['24155-10345-2601'] === '/static/procurement-progression-profile') {
	solutionURLByVertical['24155-10345-2601'] = '/case-identity';
}

if (!solutionURLByVertical['24155-10357-2501'] || solutionURLByVertical['24155-10357-2501'] === '/static/litigation-lifecycle-effort-profile') {
	solutionURLByVertical['24155-10357-2501'] = '/case-identity';
}

if (!solutionURLByVertical['24155-10345-2501'] || solutionURLByVertical['24155-10345-2501'] === '/static/procurement-progression-profile') {
	solutionURLByVertical['24155-10345-2501'] = '/case-identity';
}

if (!solutionURLByVertical['24155-10344-2601'] || solutionURLByVertical['24155-10344-2601'] === '/case-console') {
	solutionURLByVertical['24155-10344-2601'] = '/static/scm-back-office-workbench';
}

if (!solutionURLByVertical['24155-10344-2501'] || solutionURLByVertical['24155-10344-2501'] === '/case-console') {
	solutionURLByVertical['24155-10344-2501'] = '/static/scm-back-office-workbench';
}

if (!solutionURLByVertical['24155-10341-2601'] || solutionURLByVertical['24155-10341-2601'] === '/case-console') {
	solutionURLByVertical['24155-10341-2601'] = '/static/scm-buyer-assignment';
}

if (!solutionURLByVertical['24155-10341-2501'] || solutionURLByVertical['24155-10341-2501'] === '/case-console') {
	solutionURLByVertical['24155-10341-2501'] = '/static/scm-buyer-assignment';
}

if (!solutionURLByVertical['24155-10342-2601'] || solutionURLByVertical['24155-10342-2601'] === '/case-console') {
	solutionURLByVertical['24155-10342-2601'] = '/static/buyer-workbench';
}

if (!solutionURLByVertical['24155-10342-2501'] || solutionURLByVertical['24155-10342-2501'] === '/case-console') {
	solutionURLByVertical['24155-10342-2501'] = '/static/buyer-workbench';
}

if (!solutionURLByVertical['24155-10338-2601'] || solutionURLByVertical['24155-10338-2601'] === '/case-console') {
	solutionURLByVertical['24155-10338-2601'] = '/static/scm-kanban';
}

if (!solutionURLByVertical['24155-10338-2501'] || solutionURLByVertical['24155-10338-2501'] === '/case-console') {
	solutionURLByVertical['24155-10338-2501'] = '/static/scm-kanban';
}

if (!solutionURLByVertical['24155-10358-2601'] || solutionURLByVertical['24155-10358-2601'] === '/case-console') {
	solutionURLByVertical['24155-10358-2601'] = '/static/litigation-workbench';
}

if (!solutionURLByVertical['24155-10358-2501'] || solutionURLByVertical['24155-10358-2501'] === '/case-console') {
	solutionURLByVertical['24155-10358-2501'] = '/static/litigation-workbench';
}

if (!solutionURLByVertical['24155-10359-2601'] || solutionURLByVertical['24155-10359-2601'] === '/case-console') {
	solutionURLByVertical['24155-10359-2601'] = '/static/litigation-kanban';
}

if (!solutionURLByVertical['24155-10359-2501'] || solutionURLByVertical['24155-10359-2501'] === '/case-console') {
	solutionURLByVertical['24155-10359-2501'] = '/static/litigation-kanban';
}

if (!solutionURLByVertical['24155-10352-2601'] || solutionURLByVertical['24155-10352-2601'] === '/case-console') {
	solutionURLByVertical['24155-10352-2601'] = '/static/legal-action-performance-manager';
}

if (!solutionURLByVertical['24155-10352-2501'] || solutionURLByVertical['24155-10352-2501'] === '/case-console') {
	solutionURLByVertical['24155-10352-2501'] = '/static/legal-action-performance-manager';
}

if (!solutionURLByVertical['24155-10413-2601'] || solutionURLByVertical['24155-10413-2601'] === '/business-case') {
	solutionURLByVertical['24155-10413-2601'] = '/static/business-case';
}

if (!solutionURLByVertical['24155-10290-2601'] || solutionURLByVertical['24155-10290-2601'] === '/business-case') {
	solutionURLByVertical['24155-10290-2601'] = '/static/business-case';
}

if (!solutionURLByVertical['24155-10414-2601'] || solutionURLByVertical['24155-10414-2601'] === '/intercompany-fund-request') {
	solutionURLByVertical['24155-10414-2601'] = '/static/intercompany-fund-request';
}
if (!solutionURLByVertical['24155-10415-2601'] || solutionURLByVertical['24155-10415-2601'] === '/fund-allocation-plan-workbench') {
	solutionURLByVertical['24155-10415-2601'] = '/static/fund-allocation-plan-workbench';
}
if (!solutionURLByVertical['24155-10416-2601'] || solutionURLByVertical['24155-10416-2601'] === '/donor-allocation') {
	solutionURLByVertical['24155-10416-2601'] = '/static/donor-allocation';
}
if (!solutionURLByVertical['24155-10419-2601'] || solutionURLByVertical['24155-10419-2601'] === '/bank-account-master') {
	solutionURLByVertical['24155-10419-2601'] = '/static/bank-account-master';
}
